var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaestro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 15,
    viewBox: "0 0 25 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Maestro"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Left",
    d: "M14.8173 7.12662C14.8173 10.939 11.5004 14.0296 7.40866 14.0296C3.31697 14.0296 0 10.939 0 7.12662C0 3.3142 3.31697 0.223633 7.40866 0.223633C11.5004 0.223633 14.8173 3.3142 14.8173 7.12662Z",
    fill: "#ED0006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Right",
    d: "M24.4285 7.12662C24.4285 10.939 21.1116 14.0296 17.0199 14.0296C12.9282 14.0296 9.61121 10.939 9.61121 7.12662C9.61121 3.3142 12.9282 0.223633 17.0199 0.223633C21.1116 0.223633 24.4285 3.3142 24.4285 7.12662Z",
    fill: "#0099DF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Middle",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2143 12.3809C10.6214 11.1148 9.61133 9.23077 9.61133 7.12697C9.61133 5.02317 10.6214 3.13918 12.2143 1.87305C13.8073 3.13918 14.8173 5.02317 14.8173 7.12697C14.8173 9.23077 13.8073 11.1148 12.2143 12.3809Z",
    fill: "#6C6BBD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaestro);
export default __webpack_public_path__ + "static/media/Maestro.9c1ba244cdbb49a24c4d4cf8c9573b7f.svg";
export { ForwardRef as ReactComponent };